export const REPORT_NAME = 'User List';
export const GET_USERS_TASK_NAME = 'user-list-report.get-users';
export const GET_USERS_TASK_PROGRESS_LABEL = 'Searching for users for the report...';
export const TASK_NAME = 'user-list-report.get-users';
export const FILE_NAME = 'PitchBook-user-list-report';
export const STATIC_FILE_HEADERS = {
    id: 'User ID',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    userType: 'User Type',
    userStatus: 'User Status',
    jobTitle: 'Job Title',
    workPhone: 'Work Phone',
    groupName: 'Group',
    country: 'Country',
    city: 'City',
    newsletters: 'Newsletters',
    lastPlatformActivities: 'Last Platform Active',
    lastMobileActivities: 'Last Mobile Active',
    createdDate: 'Created Date',
    creatorId: 'Creator ID',
    creatorFullName: 'Creator Full Name',
    lastUpdatedDate: 'Last Updated Date',
    lastModifierId: 'Last Modifier ID',
    lastModifierFullName: 'Last Modifier Full Name',
    lastUpdateSource: 'Last Update Source',
    lastUpdateReason: 'Last Update Reason',
};

export const CHUNK_SIZE = 100;
